import * as ɵngcc0 from '@angular/core';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { ResourceHandler } from '@ngx-resource/core';
var ResourceHandlerAbstract = /** @class */ (function (_super) {
    __extends(ResourceHandlerAbstract, _super);
    function ResourceHandlerAbstract() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourceHandlerAbstract.prototype.handle = function (req) {
        var _this = this;
        var request = this.prepareRequest(req);
        var resp = {
            promise: null
        };
        resp.promise = new Promise(function (resolve, reject) {
            var subscription = _this.request(request)
                .subscribe(function (resp) {
                subscription = null;
                resolve(_this.handleResponse(req, resp));
            }, function (err) {
                subscription = null;
                reject(_this.handleResponse(req, err));
            });
            resp.abort = function () {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = null;
                }
            };
        });
        return resp;
    };
ResourceHandlerAbstract.ɵfac = /*@__PURE__*/ function () { var ɵResourceHandlerAbstract_BaseFactory; return function ResourceHandlerAbstract_Factory(t) { return (ɵResourceHandlerAbstract_BaseFactory || (ɵResourceHandlerAbstract_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(ResourceHandlerAbstract)))(t || ResourceHandlerAbstract); }; }();
ResourceHandlerAbstract.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ResourceHandlerAbstract, factory: function (t) { return ResourceHandlerAbstract.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResourceHandlerAbstract, [{
        type: Injectable
    }], null, null); })();
    return ResourceHandlerAbstract;
}(ResourceHandler));
export { ResourceHandlerAbstract };

